var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;

  return _c('main', {
    staticClass: "main page_dashboard"
  }, [_c('h1', {
    staticClass: "title--page"
  }, [_vm._v(" " + _vm._s(_vm.pageTitle) + " ")]), _c(_setup.RowItem, [_c('div', {
    staticClass: "news col_8"
  }, [_vm.news.title ? _c('router-link', {
    attrs: {
      "to": {
        name: 'news'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.news.title) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "phone col_4"
  }, [_vm._v(" 欠席受付番号 "), _c('span', [_vm._v(_vm._s(_setup.phoneAttendance))])])]), _c('div', {
    staticClass: "forum-wrapper"
  }, [_setup.schoolPlan.forum ? _c(_setup.LatestSchoolForum) : _vm._e(), _setup.schoolPlan.forum && _vm.school.government && _vm.school.government.length > 0 ? _c(_setup.LatestGovernmentForum) : _vm._e()], 1), _c(_setup.RowItem, {
    staticClass: "start between dashboard_top"
  }, [_c(_setup.LatestAttendanceCounter), _c(_setup.LatestAbsenceInfo, {
    attrs: {
      "is-loading": _vm.isLoading.attendance,
      "attendances": _vm.attendances
    }
  }), _c('div', {
    staticClass: "logs_information"
  }, [_c('div', {
    staticClass: "logs"
  }, [_c(_setup.RowItem, {
    staticClass: "between heading"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("最近ログインした先生")]), _c('router-link', {
    staticClass: "show_button",
    attrs: {
      "to": {
        name: 'logs.login'
      }
    }
  }, [_vm._v(" 一覧を見る ")])], 1)], 1), _c('div', {
    staticClass: "logs"
  }, [_c(_setup.RowItem, {
    staticClass: "between heading"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("最近のお知らせ")]), _c('router-link', {
    staticClass: "show_button",
    attrs: {
      "to": {
        name: 'messages'
      }
    }
  }, [_vm._v(" 一覧を見る ")])], 1)], 1), _c('div', {
    staticClass: "logs"
  }, [_c(_setup.RowItem, {
    staticClass: "between heading"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("最近のアンケート")]), _c('router-link', {
    staticClass: "show_button",
    attrs: {
      "to": {
        name: 'enquetes'
      }
    }
  }, [_vm._v(" 一覧を見る ")])], 1)], 1)])], 1), _c('div', {
    staticClass: "flex_box"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.school.name) + " 全校" + _vm._s(_vm.studentAddress) + "出欠席 " + _vm._s(_vm.currentDt) + "現在 ")]), _vm.schoolAbsentTotal !== null ? _c('div', {
    staticClass: "summary_counts"
  }, [_c('span', {
    staticClass: "summary_counts__item"
  }, [_vm._v(" 欠席者数 "), _c('strong', [_vm._v(_vm._s(_vm.schoolAbsentTotal))]), _vm._v(" 名 ")]), _c('span', {
    staticClass: "summary_counts__item"
  }, [_vm._v(" 遅刻・早退の給食なし "), _c('strong', [_vm._v(_vm._s(_vm.schoolLunchSkipTotal))]), _vm._v(" 名 ")])]) : _vm._e(), _c('div', {
    staticClass: "button_wrap"
  }, [_c('section', {
    staticClass: "switch_button__small"
  }, [_c('button', {
    staticClass: "switch_button__left item",
    class: {
      active: !_vm.isGradeTables
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleDashboard(false);
      }
    }
  }, [_vm._v(" 欠席者数 ")]), _c('button', {
    staticClass: "switch_button__right item",
    class: {
      active: _vm.isGradeTables
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.toggleDashboard(true);
      }
    }
  }, [_vm._v(" 欠席者一覧 ")])])])]), _vm.isGradeTables ? _c(_setup.GradeTable, {
    attrs: {
      "today-attendance": _vm.todayAttendance
    }
  }) : _c(_setup.AllClassAbsenceCounter, {
    on: {
      "update-time": _vm.updateCurrentTime,
      "update-summary": _vm.onUpdateSummary
    }
  }), _vm.showModal ? _c(_setup.MessageModal, {
    attrs: {
      "use-sub-button": true,
      "sub-button-message": '詳しく確認する'
    },
    on: {
      "close": _vm.closeMessageModal,
      "click-sub-button": _vm.navigateToElevate
    }
  }) : _vm._e()], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };